import React, { useEffect, useMemo } from "react"
import { Card, Row, Col } from "reactstrap"
import Select from "components/Shared/TranslatedSelect"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getBrandList } from "store/actions/brandsAction"
import { getMenusWithoutPagination } from "store/actions/menuSetupAction"
import {
  setSelectedCountry,
  setSelectedBrand,
  setSelectedMenu,
} from "store/menuFilter/action"
import { getCountryList } from "store/actions/countriesAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useBrandOptions } from "hooks"
import {
  buildMenuFetchParams,
  mapMenusToSelectOptions,
} from "utils/menuSelectUtils"
import useCrossModuleFilterPermissions from "hooks/useCrossModuleFilterPermissions"

const FILTER_SELECT_MENU_PROPS = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
}

const filterSelectStyles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: base => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: base => ({
    ...base,
    maxHeight: 220,
    overflowY: "auto",
  }),
}

const MenuFilters = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()

  const { selectedCountry, selectedBrand, selectedMenu } = useSelector(
    state => state.MenuFilterReducer
  )
  const { hasOnlyOneBrand, allowedBrands } = useBrandOptions()

  // const { userRole, accountType } = useSelector(state => state.Login)

  // const { menuPermission, eStorePermission } = useMemo(() => {
  //   return {
  //     menuPermission: isPermissionEnabled(userRole, 44, "FNB", accountType),
  //     eStorePermission: isPermissionEnabled(userRole, 44, "B2C", accountType),
  //   }
  // }, [userRole, accountType])

  // const { brandList } = useSelector(state => state.Brands)

  const { countryList } = useSelector(state => state.Countries)
  const { canFilterByCountry } = useCrossModuleFilterPermissions()

  const { allMenus } = useSelector(state => state.MenuSetup)

  useEffect(() => {
    if (hasOnlyOneBrand && !selectedBrand) {
      const brandOption = {
        value: allowedBrands[0]._id,
        label: allowedBrands[0].brandName,
      }
      dispatch(setSelectedBrand(brandOption))
    }
  }, [allowedBrands, selectedBrand, dispatch])

  // const allowedBrands = brandList.filter(brand => {
  //   if (brand.brandName === "FNB" && menuPermission) return true
  //   if (brand.brandName === "B2C" && eStorePermission) return true
  //   return false
  // })

  // Auto select brand if only one option exists
  useEffect(() => {
    if (hasOnlyOneBrand && !selectedBrand) {
      const brandOption = {
        value: allowedBrands[0]._id,
        label: allowedBrands[0].brandName,
      }
      dispatch(setSelectedBrand(brandOption))
    }
  }, [allowedBrands, selectedBrand, dispatch])

  useEffect(() => {
    if (!canFilterByCountry) return
    dispatch(getCountryList())
    // dispatch(getBrandList())
  }, [canFilterByCountry, dispatch])

  useEffect(() => {
    const params = buildMenuFetchParams(selectedBrand, selectedCountry)
    if (params) {
      dispatch(getMenusWithoutPagination(params))
    }
  }, [selectedCountry, selectedBrand, dispatch])

  const brandOptions =
    allowedBrands.map(obj => ({
      value: obj._id,
      label: obj.brandName,
    })) || []

  const menuOptions = mapMenusToSelectOptions(allMenus, i18n.language)

  const countryOptions = countryList?.map(item => ({
    label: i18n.language === "sa" ? item.nameAr : item.name,
    value: item.countryCode,
  }))

  return (
    <Row>
      <Col xl={12}>
        <Card className="p-3">
          <div className="portal-filter-bar portal-menu-filters" data-col-size="4">
            <div className="portal-filter-bar__item">
              <label>{t("Select Country")}</label>
              <Select
                value={selectedCountry}
                onChange={option => dispatch(setSelectedCountry(option))}
                options={countryOptions}
                placeholder={t("Select Country")}
                className="select2-selection"
                noOptionsMessage={() => t("No options")}
                styles={filterSelectStyles}
                {...FILTER_SELECT_MENU_PROPS}
              />
            </div>
            <div className="portal-filter-bar__item">
              <label>{t("Select Brand")}</label>
              <Select
                value={selectedBrand}
                onChange={option => dispatch(setSelectedBrand(option))}
                options={brandOptions}
                placeholder={t("Select Brand")}
                className="select2-selection"
                noOptionsMessage={() => t("No options")}
                styles={filterSelectStyles}
                {...FILTER_SELECT_MENU_PROPS}
              />
            </div>
            <div className="portal-filter-bar__item">
              <label>{t("Select Menu")}</label>
              <Select
                value={selectedMenu}
                onChange={option => dispatch(setSelectedMenu(option))}
                options={menuOptions}
                placeholder={t("Select Menu")}
                isDisabled={!menuOptions?.length}
                className="select2-selection"
                noOptionsMessage={() => t("No options")}
                styles={filterSelectStyles}
                {...FILTER_SELECT_MENU_PROPS}
              />
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  )
}

export default MenuFilters
